var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14342 9.82031C3.94022 9.82031 2.96484 10.7957 2.96484 11.9989V35.9989C2.96484 37.2021 3.94022 38.1775 5.14342 38.1775H42.8577C44.0609 38.1775 45.0363 37.2021 45.0363 35.9989V11.9989C45.0363 10.7957 44.0609 9.82031 42.8577 9.82031H5.14342ZM0.464844 11.9989C0.464844 9.41498 2.55951 7.32031 5.14342 7.32031H42.8577C45.4416 7.32031 47.5363 9.41498 47.5363 11.9989V35.9989C47.5363 38.5828 45.4416 40.6775 42.8577 40.6775H5.14342C2.55951 40.6775 0.464844 38.5828 0.464844 35.9989V11.9989Z",
    fill: "#79C2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0017 18.3926C20.9049 18.3926 18.3945 20.903 18.3945 23.9997C18.3945 27.0965 20.9049 29.6069 24.0017 29.6069C27.0984 29.6069 29.6088 27.0965 29.6088 23.9997C29.6088 20.903 27.0984 18.3926 24.0017 18.3926ZM15.8945 23.9997C15.8945 19.5223 19.5242 15.8926 24.0017 15.8926C28.4791 15.8926 32.1088 19.5223 32.1088 23.9997C32.1088 28.4772 28.4791 32.1069 24.0017 32.1069C19.5242 32.1069 15.8945 28.4772 15.8945 23.9997Z",
    fill: "#79C2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4232 23.9997C10.6341 23.7759 10.7634 23.4744 10.7634 23.1426C10.7634 22.4522 10.2037 21.8926 9.51339 21.8926C8.34965 21.8926 7.40625 22.836 7.40625 23.9997C7.40625 25.1635 8.34965 26.1069 9.51339 26.1069C10.2037 26.1069 10.7634 25.5472 10.7634 24.8569C10.7634 24.5251 10.6341 24.2235 10.4232 23.9997Z",
    fill: "#79C2D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60411 23.9997C8.39321 23.7759 8.26395 23.4744 8.26395 23.1426C8.26395 22.4522 8.82359 21.8926 9.51395 21.8926C10.6777 21.8926 11.6211 22.836 11.6211 23.9997C11.6211 25.1635 10.6777 26.1069 9.51395 26.1069C8.82359 26.1069 8.26395 25.5472 8.26395 24.8569C8.26395 24.5251 8.39321 24.2235 8.60411 23.9997Z",
    fill: "#79C2D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3959 23.9997C39.6068 23.7759 39.736 23.4744 39.736 23.1426C39.736 22.4522 39.1764 21.8926 38.486 21.8926C37.3223 21.8926 36.3789 22.836 36.3789 23.9997C36.3789 25.1635 37.3223 26.1069 38.486 26.1069C39.1764 26.1069 39.736 25.5472 39.736 24.8569C39.736 24.5251 39.6068 24.2235 39.3959 23.9997Z",
    fill: "#79C2D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5768 23.9997C37.3659 23.7759 37.2366 23.4744 37.2366 23.1426C37.2366 22.4522 37.7963 21.8926 38.4866 21.8926C39.6503 21.8926 40.5938 22.836 40.5938 23.9997C40.5938 25.1635 39.6503 26.1069 38.4866 26.1069C37.7963 26.1069 37.2366 25.5472 37.2366 24.8569C37.2366 24.5251 37.3659 24.2235 37.5768 23.9997Z",
    fill: "#79C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.55be00feea3e52218460c1bd688c20b8.svg";
export { ForwardRef as ReactComponent };